"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeTargeting = exports.updateTargeting = exports.getAdBlockerEventParams = exports.isAdsBlocked = exports.initializeClear = exports.getScripts = exports.getAssetsUrl = exports.checkExperimentsForAdsEligibility = void 0;
var PROD_UCI_ASSETS_URL = 'https://www.uciservice.com/assets/';
var INT_UCI_ASSETS_URL = 'https://www.uciservice.com/assets-int/';
var intExpediaEnvOptions = Object.values(['test', 'development']);
function checkExperimentsForAdsEligibility(experiment) {
  if (!experiment) {
    return true;
  }
  var adsFeatureGate = experiment && experiment.exposures && experiment.exposures["meso_ads_feature_gate"];
  if ((adsFeatureGate === null || adsFeatureGate === void 0 ? void 0 : adsFeatureGate.bucket) === 1) {
    return false;
  }
  return true;
}
exports.checkExperimentsForAdsEligibility = checkExperimentsForAdsEligibility;
function getAssetsUrl() {
  var _a;
  return intExpediaEnvOptions.includes((_a = process.env.EXPEDIA_ENVIRONMENT) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ? INT_UCI_ASSETS_URL : PROD_UCI_ASSETS_URL;
}
exports.getAssetsUrl = getAssetsUrl;
function getScripts() {
  var UCI_ASSETS_URL = getAssetsUrl();
  var scripts = [{
    src: UCI_ASSETS_URL + 'meso-loaders/bernie-loader.js',
    type: 'module'
  }];
  return scripts;
}
exports.getScripts = getScripts;
function initializeClear() {
  // Clear the ADS cache.
  window.meso = window.meso || {};
  window.meso.initialize = window.meso.initialize || [];
  window.meso.initialize.push({
    type: 'clear'
  });
}
exports.initializeClear = initializeClear;
function isAdsBlocked() {
  var _a, _b;
  return !!+((_b = (_a = localStorage.getItem('eg_adblock')) === null || _a === void 0 ? void 0 : _a.split('|')[0]) === null || _b === void 0 ? void 0 : _b.split('=')[1]);
}
exports.isAdsBlocked = isAdsBlocked;
function getAdblockStatus() {
  var adBlockStatus = {
    enabled: false
  };
  // used to convert the keys from the localStorage to the keys in the Adblock interface
  var keyNames = {
    e: 'enabled',
    aaa: 'acceptableads'
  };
  var parts = localStorage.getItem('eg_adblock');
  if (!parts) {
    return adBlockStatus;
  }
  parts.split('|').forEach(function (part) {
    var _a = __read(part.split('='), 2),
      key = _a[0],
      _b = _a[1],
      value = _b === void 0 ? '0' : _b;
    adBlockStatus[keyNames[key]] = !!+value;
  });
  return adBlockStatus;
}
function getAdBlockerEventParams() {
  var adblockStatus = getAdblockStatus();
  var status = adblockStatus.enabled ? 'enabled' : 'disabled';
  var acceptableAdStatus = adblockStatus.acceptableads ? 'enabled' : 'unknown';
  return {
    referrer: "adblocker." + status + ",acceptableads." + acceptableAdStatus,
    linkName: "adblocker status: " + status + ",acceptableads:" + acceptableAdStatus
  };
}
exports.getAdBlockerEventParams = getAdBlockerEventParams;
function updateTargeting(targetingData) {
  initializeTargeting();
  if (targetingData && window) {
    var targetingEvent = {
      type: 'update',
      targeting: targetingData
    };
    window.meso.targeting.push(targetingEvent);
  }
}
exports.updateTargeting = updateTargeting;
function initializeTargeting() {
  var _a, _b;
  if (window) {
    window.meso = (_a = window.meso) !== null && _a !== void 0 ? _a : {};
    window.meso.targeting = (_b = window.meso.targeting) !== null && _b !== void 0 ? _b : [];
  }
}
exports.initializeTargeting = initializeTargeting;